import {create} from "zustand";
import {IKindsTraining} from "../../pages/admissions/model/admissionModel";

export interface ICompetition {
    value: string;
    display: string;
}

export interface IOtherPayer {
    surname?: string | undefined,
    name?: string | undefined,
    patronymic?: string | undefined,
    snils?: string | undefined,
    gender?: string | undefined,
    birthdate?: string | undefined,
    telephone?: string | undefined,
    email?: string | undefined,
    citizenship?: string | undefined,
}

export interface IKindsLevelFormation {
    value: string;
    display: string,
    name: string
}

export interface ISpecialityProfile {
    name: string,
    code: string
}

export interface IConcourseGroup {
    concourseGroupsCode: string,
    specQualifier: string,
    competitioncode: string,
    specName: string
    profiles: ISpecialityProfile[],
    kindsLevelFormation: IKindsLevelFormation,
    kindsTraining: IKindsTraining,
    typecompetition: string,
    basistraining: string,
    price: string,
    number: string
}

export interface IConcourseGroupsPriorityProfile {
    profilecode: string,
    priority: number
}

export interface IConcourseGroupsPriority {
    code: string,
    priority: number,
    profiles: IConcourseGroupsPriorityProfile[]
}

export interface IConsent {
    inForm: boolean,
    confirm: boolean,
    confirmpersdata: boolean,
}

export interface IExamDetails {
    ExamCode: string,
    ClassroomID: string | undefined,
    Date: string | undefined,
    Classroom: string | undefined,
    id: string | undefined,
    TimeStart: string | undefined
}

export interface IAdmissionResult {
    basistraining: string;
    kindsLevelFormation: string;
    needador: boolean;
    selectedConcourceGroupsCodes: string[],
    selectedSpecQualifier: string[],
    concourseGroupsPriority: IConcourseGroupsPriority[],
    kindsTrainingCode: string,
    exams: IExamDetails[]
    offernumber: string,
    offernumberposted: boolean,
    surname: string,
    name: string,
    competition: string,
    patronymic: string,
    snils: string,
    gender: string,
    birthdate: string,
    telephone: string,
    email: string,
    citizenship: string,
    education: string,
    categories: any | null,
    achievements: any | null,
    EG: boolean,
    Bookentryexams: boolean,
    Iampayer: boolean,
    notcontract: boolean,
    otherpayerChecked: boolean,
    consent: IConsent,
    otherpayer: IOtherPayer | null,
}

export interface IAdmissionResultStore {
    result: IAdmissionResult;
    setResult: (result: IAdmissionResult) => void;
}

export const defaultResult = {
    basistraining: "",
    kindsLevelFormation: "",
    needador: false,
    selectedConcourceGroupsCodes: [],
    selectedSpecQualifier: [],
    concourseGroupsPriority: [],
    kindsTrainingCode: "",
    exams: [],
    offernumber: "",
    offernumberposted: false,
    surname: "",
    name: "",
    competition: "",
    patronymic: "",
    snils: "",
    gender: "",
    birthdate: "",
    telephone: "",
    email: "",
    citizenship: "",
    education: "",
    categories: null,
    achievements: null,
    EG: false,
    Bookentryexams: false,
    Iampayer: false,
    notcontract: false,
    otherpayerChecked: false,
    otherpayer: null,
    consent: {
        inForm: false,
        confirm: false,
        confirmpersdata: false
    }
}

export const resultStore = create<IAdmissionResultStore>()((set) => ({
    result: defaultResult,
    setResult: (result) => set((state) => ({result: result})),
}))

//Данные по специальностям
export interface IAdmissionState {
    selectedKindsLevels: string
    setSelectedKindsLevels: (newData: any) => void
}

export const admissionStore = create<IAdmissionState>()((set) => ({
    selectedKindsLevels: "",
    setSelectedKindsLevels: (newData) => set((state) => ({selectedKindsLevels: newData})),
}))

// Конкурсные группы
export interface IConcourseGroups {
    concourseGroups: IConcourseGroup[]
    setConcourseGroups: (newData: any) => void
}

export const concourseGroupsStore = create<IConcourseGroups>()((set) => ({
    concourseGroups: [],
    setConcourseGroups: (newData) => set((state) => ({concourseGroups: newData})),
}))

// Конкурсные группы
export interface ICompetitions {
    competitions: ICompetition[]
    setCompetitions: (newData: any) => void
}

export const competitionsStore = create<ICompetitions>()((set) => ({
    competitions: [],
    setCompetitions: (newData) => set((state) => ({competitions: newData})),
}))


// Уровни образования
export interface IKindsLevelFormationStore {
    kindsLevelFormations: IKindsLevelFormation[]
    setKindsLevelFormations: (newData: IKindsLevelFormation[]) => void
}

export const kindsLevelFormationsStore = create<IKindsLevelFormationStore>()((set) => ({
    kindsLevelFormations: [],
    setKindsLevelFormations: (newData: IKindsLevelFormation[]) => set((state) => ({kindsLevelFormations: newData})),
}))


